import type {
  ColDef,
  GetRowIdParams,
  GridReadyEvent,
  RowClassParams,
  RowClickedEvent,
  SortChangedEvent,
} from 'ag-grid-community'
import { AgGridReact } from 'ag-grid-react'

interface AdminDataGridProps<T extends object> {
  rows: T[]
  columns: Array<ColDef<T>>
  loading?: boolean
  emptyMessage?: string
  height?: number | string
  rowHeight?: number
  getRowId?: (params: GetRowIdParams<T>) => string
  getRowClass?: (params: RowClassParams<T>) => string | string[] | undefined
  onGridReady?: (event: GridReadyEvent<T>) => void
  onRowClicked?: (event: RowClickedEvent<T>) => void
  onSortChanged?: (event: SortChangedEvent<T>) => void
}

export function AdminDataGrid<T extends object>({
  rows,
  columns,
  loading = false,
  emptyMessage = 'No rows found',
  height = 560,
  rowHeight = 58,
  getRowId,
  getRowClass,
  onGridReady,
  onRowClicked,
  onSortChanged,
}: AdminDataGridProps<T>) {
  return (
    <div
      className="lookbook-ag-grid ag-theme-quartz overflow-hidden rounded-lg border border-dashed border-border bg-surface"
      style={{ height }}
    >
      <AgGridReact<T>
        rowData={rows}
        columnDefs={columns}
        defaultColDef={{
          minWidth: 120,
          resizable: true,
          sortable: false,
          suppressHeaderMenuButton: true,
        }}
        animateRows
        enableCellTextSelection
        getRowClass={getRowClass}
        getRowId={getRowId}
        headerHeight={44}
        loading={loading}
        onGridReady={onGridReady}
        onRowClicked={onRowClicked}
        onSortChanged={onSortChanged}
        overlayLoadingTemplate={'<span class="lookbook-grid-overlay">Loading…</span>'}
        overlayNoRowsTemplate={`<span class="lookbook-grid-overlay">${emptyMessage}</span>`}
        rowHeight={rowHeight}
        suppressCellFocus
        suppressRowClickSelection
        suppressColumnMoveAnimation
        suppressDragLeaveHidesColumns
        suppressMovableColumns
        suppressMultiSort
      />
    </div>
  )
}
